/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicTicketEvent } from './PublicTicketEvent';
import {
    PublicTicketEventFromJSON,
    PublicTicketEventFromJSONTyped,
    PublicTicketEventToJSON,
    PublicTicketEventToJSONTyped,
} from './PublicTicketEvent';

/**
 * 
 * @export
 * @interface ResultOfIReadOnlyListOfPublicTicketEvent
 */
export interface ResultOfIReadOnlyListOfPublicTicketEvent {
    /**
     * 
     * @type {Array<PublicTicketEvent>}
     * @memberof ResultOfIReadOnlyListOfPublicTicketEvent
     */
    data: Array<PublicTicketEvent> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfIReadOnlyListOfPublicTicketEvent
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfIReadOnlyListOfPublicTicketEvent
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfIReadOnlyListOfPublicTicketEvent interface.
 */
export function instanceOfResultOfIReadOnlyListOfPublicTicketEvent(value: object): value is ResultOfIReadOnlyListOfPublicTicketEvent {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfIReadOnlyListOfPublicTicketEventFromJSON(json: any): ResultOfIReadOnlyListOfPublicTicketEvent {
    return ResultOfIReadOnlyListOfPublicTicketEventFromJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfPublicTicketEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIReadOnlyListOfPublicTicketEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(PublicTicketEventFromJSON)),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfIReadOnlyListOfPublicTicketEventToJSON(json: any): ResultOfIReadOnlyListOfPublicTicketEvent {
    return ResultOfIReadOnlyListOfPublicTicketEventToJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfPublicTicketEventToJSONTyped(value?: ResultOfIReadOnlyListOfPublicTicketEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(PublicTicketEventToJSON)),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

